import { useEffect, useState } from "react";
import { LinkedInquiry, Poll } from "../interfaces/Poll"
import useHttp from "./useHttp"
import { getEnvironmentApiUrl } from "../services/General";

const useInquiriesCharts = (caseID: number) => {

    const { sendRequest: getPolls } = useHttp<Poll[]>();
    const { sendRequest: getAssignedInquiries } = useHttp<LinkedInquiry[]>();

    const [pollsWithCharts, setPollsWithCharts] = useState<Poll[]>([]);

    useEffect(() => {
        getPolls({
            url: getEnvironmentApiUrl() + 'inquiry/all',
            method: 'POST',
            body: {
                params: {},
                filter: {
                    enabled: true,
                    modified: false,
                    deleted: false,
                    show_in_charts: true,
                },
            }
        }, (polls) => {
            getAssignedInquiries({
                url: getEnvironmentApiUrl() + 'patient_inquiry/all',
                method: 'POST',
                body: {
                    params: {},
                    filter: {
                        case_id: caseID,
                        end_date: null,
                    },
                }
            }, (assignedInquiries) => {
                const pollsWithCharts = polls.filter(poll => {
                    return assignedInquiries.some(ai => ai.inquiry_id === poll.id);
                });
                setPollsWithCharts(pollsWithCharts);
            });
        });

    }, [caseID, getAssignedInquiries, getPolls]);

    return pollsWithCharts;

}

export default useInquiriesCharts;